module.exports = __webpack_public_path__ + "cdc263d1279951e0fe63195063b98238.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/avatars/rafail.jpg
// module id = 43
// module chunks = 0